import styled from 'styled-components'
import { layout } from 'styled-system'

import { Column, Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { SLIDE_WIDTH } from 'Constants/Swipers'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Column)
  .attrs({
    display: ['flex', 'none'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  align-items: center;

  ${layout}
`

export const Content = styled(Flex)
  .attrs({
    width: SLIDE_WIDTH.narrow,
  })
  .withConfig({
    shouldForwardProp,
  })`
  height: 100%;
  position: relative;
  z-index: 2;
`
